<template>
  <div>
    <Swiper>
      <swiperItem>
        <img
          src="https://portal.fuyunfeng.top/files/Naruto/061740566792.jpg_scale330x.jpg"
          alt=""
        >
      </swiperItem>
      <swiperItem>
        <img
          src="https://portal.fuyunfeng.top/files/Naruto/071532002745.jpg_scale330x.jpg"
          alt=""
        >
      </swiperItem>
      <swiperItem>
        <img
          src="https://portal.fuyunfeng.top/files/Naruto/071532043525.jpg_scale330x.jpg"
          alt=""
        >
      </swiperItem>
    </Swiper>
  </div>
</template>
<script>
import Swiper from './swiper.vue'
import swiperItem from './swiper-item.vue'

export default {
  components: { Swiper, swiperItem },
  name: 'SwipeAnimation'
}
</script>
<style lang="scss" scoped>
</style>
